export default "__VITE_ASSET__99be3588__"